import { MerchantHomePage } from "./../merchant-home/merchant-home";
// import { MerchantShopPayRentalPage } from "./../merchant-shop-pay-rental/merchant-shop-pay-rental";
import { MerchantShopRefillStockPage } from "./../merchant-shop-refill-stock/merchant-shop-refill-stock";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { MerchantRentalYourspacePage } from "./../merchant-rental-yourspace/merchant-rental-yourspace";
import { RequestOptions, Headers, Http } from "@angular/http";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
} from "ionic-angular";
import { ServiceProvider } from "../../providers/service/service";
import { MerchantShopPayRentalInputPage } from "../merchant-shop-pay-rental-input/merchant-shop-pay-rental-input";

@IonicPage()
@Component({
  selector: "page-merchant-shop-menu",
  templateUrl: "merchant-shop-menu.html",
})
export class MerchantShopMenuPage {
  plaza = "";
  space: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService
  ) {
    this.space = this.navParams.data.space;
    // console.log("space=", this.space);

    this.storage.get("info").then((info) => {
      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      } else {
        this.plaza = info.team.plaza_id;
      }
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  remove() {
    const confirm = this.alertCtrl.create({
      // title: 'Remove this shop?',
      message: "You want remove this shop?",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            // console.log('Agree clicked');
            this.storage.get("token").then((token) => {
              var link =
                this.services.URLMerchantSpace + "/" + this.space.space_no;
              var headers = new Headers();
              headers.append("Accept", "application/json");
              headers.append("Authorization", "Bearer " + token);
              const requestOptions = new RequestOptions({ headers: headers });

              this.http
                .delete(link, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    this.navCtrl.push(MerchantRentalYourspacePage);
                  },
                  (error) => {
                    var response = JSON.parse(error._body);

                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );
            });
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  refill() {
    this.navCtrl.push(MerchantShopRefillStockPage, { space: this.space });
  }

  rental() {
    this.navCtrl.push(MerchantShopPayRentalInputPage, {
      shop_name: this.space.shop.shop_name,
      shop_id: this.space.shop.shop_id,
    });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-menu/merchant-shop-menu.ts